import type { Product } from '../../model/types';

export interface Props {
    product: Product;
}

export default function ProductCategoryLinks({ product }: Props) {
    if (!product.main_category) return null;

    return (
        <>
            <a key="main-category" href={`/search?q=:relevance:mainCategory:${product.main_category.code}`}>
                {product.main_category.name}
            </a>
            {product.main_sub_category && (
                <>
                    {' - '}
                    <a
                        key="main-sub-category"
                        href={`/search?q=:relevance:mainCategory:${product.main_category.code}:mainSubCategory:${product.main_sub_category.code}`}
                    >
                        {product.main_sub_category.name}
                    </a>
                    {product.main_sub_sub_category && (
                        <>
                            {' - '}
                            <a
                                key="main-sub-sub-category"
                                href={`/search?q=:relevance:mainCategory:${product.main_category.code}:mainSubCategory:${product.main_sub_category.code}:mainSubSubCategory:${product.main_sub_sub_category.code}`}
                            >
                                {product.main_sub_sub_category.name}
                            </a>
                        </>
                    )}
                </>
            )}
        </>
    );
}
